<template>
  <div>
    <!-- Customer Scan Chart Start -->
    <div class="row mb-4 mt-4">
      <div class="col-md-6 mt-4 mb-4">
        <!-- <div class="row"> -->
        <!-- <MultiSelect
              v-model="filter.sumCustomer.year"
              :options="options.year"
              :deselect-label="''"
              :allowEmpty="false"
              placeholder="All Years"
              class="elegant-multiselect"
            /> -->
        <!-- <div class="input-group">
              <span
                class="input-group-text bg-white"
                style="
                  border-top-right-radius: 0;
                  border-bottom-right-radius: 0;
                  border-right: none;
                "
              >
                <i
                  class="fas fa-calendar"
                  style="
                    position: absolute;
                    left: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #333;
                  "
                ></i>
              </span>
              <flat-pickr
                :config="rangePickr"
                placeholder="Select Date"
                v-model="selected.date.sumCustomer"
              ></flat-pickr>
            </div> -->
        <!-- </div> -->

        <!-- <div class="row pb-4">
          <div class="ml-auto" style="min-width: 200px">
            Content of the right div
            <div class="input-group">
              <span
                class="input-group-text bg-white"
                style="
                  border-top-right-radius: 0;
                  border-bottom-right-radius: 0;
                  border-right: none;
                "
              >
                <i
                  class="fas fa-calendar"
                  style="
                    position: absolute;
                    left: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #333;
                  "
                ></i>
              </span>
              <flat-pickr
                :config="rangePickr"
                placeholder="Select Date"
              ></flat-pickr>
              v-model="selected.date"
            </div>
          </div>
        </div> -->

        <div class="bg-white shadow box-content mt-3 mb-5">
          <div class="row">
            <div class="col-md-6" style="align-self: center">
              <h4 class="text-left" style="margin-bottom: 0">
                Customer Scan Result
              </h4>
            </div>
            <div
              class="row col-md-6 justify-content-end"
              style="padding-right: 0"
            >
              <div class="col-md-7" style="padding-right: 0">
                <div class="input-group">
                  <flat-pickr
                    :config="rangePickr"
                    placeholder="Select Date"
                    v-model="selected.date.sumCustomer"
                    class="form-control"
                  ></flat-pickr>
                  <!-- style="padding-right: 2.5rem" -->
                  <span
                    class="input-group-text bg-white"
                    style="
                      position: absolute;
                      right: 0.75rem;
                      top: 50%;
                      transform: translateY(-50%);
                      border: none;
                      background: transparent;
                      pointer-events: none;
                    "
                  >
                    <i class="fas fa-caret-down" style="color: #333"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div>
                <sumCustomerScanDetailed
                  v-if="data.sumCustomer"
                  :chartData="data.sumCustomer"
                ></sumCustomerScanDetailed>
                <div v-else class="text-center mt-5 mb-5">
                  <h2 class="pt-5 pb-5">Loading...</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <hr /> -->
      <!-- Customer Scan Chart End -->

      <!-- Claim MD Chart Start -->
      <div class="col-md-6 mt-4 mb-4">
        <!-- <div class="row"></div> -->
        <div class="bg-white shadow box-content mt-3 mb-5">
          <div class="row">
            <div class="col-md-6" style="align-self: center">
              <h4 class="text-left" style="margin-bottom: 0">
                Claim Main Dealer
              </h4>
            </div>
            <div
              class="row col-md-6 justify-content-end"
              style="padding-right: 0"
            >
              <!-- <MultiSelect
              v-model="filter.sumClaimMD.year"
              :options="options.year"
              :deselect-label="''"
              :allowEmpty="false"
              placeholder="All Years"
              class="elegant-multiselect"
              /> -->
              <div class="col-md-7" style="padding-right: 0">
                <div class="input-group">
                  <!-- <span
                  class="input-group-text bg-white"
                  style="
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 0;
                    border-right: none;
                  "
                
                  <i
                    class="fas fa-caret-down"
                    style="
                      position: absolute;
                      left: 10px;
                      top: 50%;
                      transform: translateY(-50%);
                      color: #333;
                    "
                  ></i>
                  </span> -->
                  <flat-pickr
                    :config="rangePickr"
                    placeholder="Select Date"
                    v-model="selected.date.sumClaimMD"
                  ></flat-pickr>
                  <span
                    class="input-group-text bg-white"
                    style="
                      position: absolute;
                      right: 0.75rem;
                      top: 50%;
                      transform: translateY(-50%);
                      border: none;
                      background: transparent;
                      pointer-events: none;
                    "
                  >
                    <i class="fas fa-caret-down" style="color: #333"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div>
                <sumClaimMDDetailed
                  v-if="data.sumClaimMD"
                  :chartData="data.sumClaimMD"
                ></sumClaimMDDetailed>
                <div v-else class="text-center mt-5 mb-5">
                  <h2 class="pt-5 pb-5">Loading...</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <hr /> -->
    <!-- Claim MD Chart End -->

    <!-- Label Maker Table Start -->
    <div class="bg-white shadow box-content mt-3 mb-5">
      <div class="row">
        <div class="col-md-6" style="align-self: center">
          <h4 class="text-left" style="margin-bottom: 0">Report Label Maker</h4>
        </div>
        <div class="row col-md-6 justify-content-end" style="padding-right: 0">
          <div class="col-md-5">
            <MultiSelect
              v-model="filter.sumLabelCahaya.labelmaker"
              :options="options.sumLabelCahaya.labelmaker"
              :deselect-label="''"
              :select-label="''"
              placeholder="All Label Maker"
              class="elegant-multiselect"
            />
          </div>
          <div class="col-md-4">
            <MultiSelect
              v-model="filter.sumLabelCahaya.year"
              :options="options.year"
              :deselect-label="''"
              :select-label="''"
              :allowEmpty="false"
              placeholder="All Years"
              class="elegant-multiselect"
            />
          </div>
        </div>
      </div>
      <!-- <div class="row">
                <div class="col-md-6">
                    <h4 class="text-center">Cahaya</h4>
                </div>
                <div class="col-md-6">
                    <h4 class="text-center">Menara</h4>
                </div>
            </div> -->
      <div class="row">
        <div class="col-md-12">
          <div>
            <sumLabelCahaya
              :data="data.sumLabelCahaya"
              v-if="!isAllZeroLabelMaker"
            ></sumLabelCahaya>
            <div v-else class="text-center mt-5 mb-5">
              <svg
                width="138"
                height="159"
                viewBox="0 0 138 159"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="63.6879"
                  cy="53.6313"
                  r="53.6313"
                  fill="#EAECF0"
                  fill-opacity="0.5"
                />
                <circle
                  cx="7.37485"
                  cy="13.4081"
                  r="5.36313"
                  fill="#F2F4F7"
                  fill-opacity="0.5"
                />
                <circle
                  cx="122.683"
                  cy="84.4696"
                  r="4.02235"
                  fill="#F2F4F7"
                  fill-opacity="0.5"
                />
                <circle
                  cx="6.70391"
                  cy="92.5145"
                  r="6.70391"
                  fill="#F2F4F7"
                  fill-opacity="0.5"
                />
                <circle
                  cx="130.725"
                  cy="25.4754"
                  r="6.70391"
                  fill="#F2F4F7"
                  fill-opacity="0.5"
                />
                <circle
                  cx="117.99"
                  cy="7.37438"
                  r="4.69274"
                  fill="#F2F4F7"
                  fill-opacity="0.5"
                />
                <g clip-path="url(#clip0_12999_3597)">
                  <path
                    d="M102.05 42.3086H28.3141C27.3193 42.3092 26.3654 42.7047 25.662 43.4081C24.9586 44.1115 24.5631 45.0654 24.5625 46.0602V113.714C24.5631 114.709 24.9586 115.662 25.662 116.366C26.3654 117.069 27.3193 117.465 28.3141 117.465H102.05C103.045 117.465 103.999 117.069 104.703 116.366C105.406 115.663 105.802 114.709 105.802 113.714V46.0602C105.802 45.0653 105.406 44.1114 104.703 43.4079C103.999 42.7045 103.045 42.3091 102.05 42.3086Z"
                    fill="#C6C6C6"
                  />
                  <path
                    d="M97.1948 93.9554H33.1676C31.0958 93.9554 29.416 92.2757 29.416 90.2038V30.4283C29.416 28.3565 31.0958 26.6768 33.1676 26.6768H97.1948C99.2666 26.6768 100.946 28.3565 100.946 30.4283V90.2038C100.946 92.2757 99.2666 93.9554 97.1948 93.9554Z"
                    fill="#F0F0F0"
                  />
                  <path
                    d="M30.6038 91.3912V31.6161C30.6038 29.5443 32.2835 27.8645 34.3553 27.8645H98.3826C99.1144 27.8645 99.7946 28.0772 100.371 28.4394C99.7082 27.3818 98.5352 26.6768 97.1948 26.6768H33.1676C31.0958 26.6768 29.416 28.3565 29.416 30.4283V90.2038C29.416 91.5446 30.1211 92.7173 31.1787 93.3809C30.8165 92.8037 30.6038 92.1234 30.6038 91.3916V91.3912Z"
                    fill="url(#paint0_linear_12999_3597)"
                  />
                  <path
                    d="M89.3178 39.3066H41.0469V42.0576H89.3178V39.3066ZM89.3178 49.8106H41.0469V52.5615H89.3178V49.8106ZM89.3178 60.3168H41.0469V63.0677H89.3178V60.3168ZM89.3178 70.8207H41.0469V73.572H89.3178V70.8207Z"
                    fill="white"
                  />
                  <path
                    d="M46.7988 61.9414L58.9287 74.0716H46.7988V61.9414Z"
                    fill="url(#paint1_linear_12999_3597)"
                  />
                  <path
                    d="M105.802 75.0728V47.1635L100.947 42.3086V75.0724H105.802V75.0728Z"
                    fill="#C6C6C6"
                  />
                  <path
                    d="M111.488 77.5975L106.257 114.622C105.996 116.473 104.412 117.849 102.543 117.849H27.8204C25.9512 117.849 24.3671 116.473 24.1056 114.622L17.0375 64.5929C16.7187 62.3344 18.4713 60.3164 20.7523 60.3164H43.8281C45.6973 60.3164 47.2813 61.6921 47.5428 63.5427L48.4691 70.0943C48.7306 71.9453 50.3146 73.321 52.1838 73.321H107.774C110.054 73.321 111.807 75.3389 111.488 77.5975H111.488Z"
                    fill="url(#paint2_linear_12999_3597)"
                  />
                  <path
                    d="M92.9571 101.333H37.4084C37.104 101.333 36.81 101.222 36.5816 101.021C36.3532 100.819 36.206 100.542 36.1676 100.24L35.4726 94.7371C35.4505 94.5611 35.4661 94.3824 35.5184 94.2128C35.5706 94.0433 35.6584 93.8868 35.7757 93.7537C35.893 93.6207 36.0373 93.5141 36.199 93.441C36.3607 93.368 36.536 93.3302 36.7135 93.3301H93.6521C93.8295 93.3302 94.0048 93.368 94.1665 93.441C94.3282 93.5141 94.4725 93.6207 94.5898 93.7537C94.7072 93.8868 94.7949 94.0433 94.8471 94.2128C94.8994 94.3824 94.915 94.5611 94.8929 94.7371L94.1979 100.24C94.1595 100.542 94.0124 100.819 93.784 101.021C93.5555 101.222 93.2616 101.333 92.9571 101.333Z"
                    fill="#D5D5D5"
                  />
                </g>
                <path
                  d="M54.4292 146.798V155.525H53.0229L48.9107 149.581H48.8382V155.525H47.2573V146.798H48.6721L52.78 152.747H52.8567V146.798H54.4292ZM58.9387 155.653C58.2995 155.653 57.7456 155.513 57.2768 155.231C56.8081 154.95 56.4444 154.557 56.1859 154.051C55.9302 153.545 55.8024 152.954 55.8024 152.278C55.8024 151.602 55.9302 151.01 56.1859 150.501C56.4444 149.993 56.8081 149.598 57.2768 149.317C57.7456 149.035 58.2995 148.895 58.9387 148.895C59.5779 148.895 60.1319 149.035 60.6007 149.317C61.0694 149.598 61.4316 149.993 61.6873 150.501C61.9458 151.01 62.0751 151.602 62.0751 152.278C62.0751 152.954 61.9458 153.545 61.6873 154.051C61.4316 154.557 61.0694 154.95 60.6007 155.231C60.1319 155.513 59.5779 155.653 58.9387 155.653ZM58.9473 154.417C59.2939 154.417 59.5836 154.322 59.8166 154.132C60.0495 153.939 60.2228 153.68 60.3365 153.356C60.4529 153.032 60.5112 152.672 60.5112 152.274C60.5112 151.873 60.4529 151.511 60.3365 151.187C60.2228 150.861 60.0495 150.601 59.8166 150.407C59.5836 150.214 59.2939 150.118 58.9473 150.118C58.5922 150.118 58.2967 150.214 58.0609 150.407C57.8279 150.601 57.6532 150.861 57.5368 151.187C57.4231 151.511 57.3663 151.873 57.3663 152.274C57.3663 152.672 57.4231 153.032 57.5368 153.356C57.6532 153.68 57.8279 153.939 58.0609 154.132C58.2967 154.322 58.5922 154.417 58.9473 154.417ZM69.3865 155.525H66.4292V146.798H69.4462C70.3127 146.798 71.057 146.973 71.6792 147.322C72.3042 147.669 72.7843 148.167 73.1195 148.818C73.4547 149.469 73.6223 150.247 73.6223 151.153C73.6223 152.062 73.4533 152.844 73.1152 153.497C72.78 154.15 72.2956 154.652 71.6621 155.001C71.0314 155.351 70.2729 155.525 69.3865 155.525ZM68.0101 154.157H69.3098C69.9178 154.157 70.4249 154.047 70.8311 153.825C71.2374 153.601 71.5428 153.267 71.7473 152.824C71.9519 152.378 72.0542 151.821 72.0542 151.153C72.0542 150.486 71.9519 149.932 71.7473 149.491C71.5428 149.048 71.2402 148.717 70.8397 148.498C70.4419 148.277 69.9476 148.166 69.3567 148.166H68.0101V154.157ZM76.9398 155.657C76.525 155.657 76.1515 155.584 75.8191 155.436C75.4895 155.285 75.2282 155.064 75.035 154.771C74.8446 154.479 74.7495 154.118 74.7495 153.689C74.7495 153.319 74.8176 153.014 74.954 152.773C75.0904 152.531 75.2765 152.338 75.5123 152.193C75.748 152.048 76.0137 151.939 76.3091 151.865C76.6074 151.788 76.9157 151.733 77.2338 151.699C77.6174 151.659 77.9284 151.623 78.1671 151.592C78.4057 151.558 78.579 151.507 78.687 151.439C78.7978 151.368 78.8532 151.258 78.8532 151.111V151.085C78.8532 150.764 78.758 150.515 78.5676 150.339C78.3773 150.163 78.1032 150.075 77.7452 150.075C77.3674 150.075 77.0676 150.157 76.8461 150.322C76.6273 150.487 76.4796 150.682 76.4029 150.906L74.9625 150.702C75.0762 150.304 75.2637 149.971 75.525 149.704C75.7864 149.434 76.106 149.233 76.4838 149.099C76.8617 148.963 77.2793 148.895 77.7367 148.895C78.052 148.895 78.3659 148.932 78.6784 149.006C78.9909 149.079 79.2765 149.202 79.535 149.372C79.7935 149.54 80.0009 149.768 80.1571 150.058C80.3162 150.348 80.3958 150.71 80.3958 151.145V155.525H78.9128V154.626H78.8617C78.7679 154.808 78.6358 154.979 78.4654 155.138C78.2978 155.294 78.0861 155.42 77.8304 155.517C77.5776 155.611 77.2807 155.657 76.9398 155.657ZM77.3404 154.524C77.65 154.524 77.9185 154.463 78.1458 154.341C78.373 154.216 78.5478 154.051 78.6699 153.846C78.7949 153.642 78.8574 153.419 78.8574 153.177V152.406C78.8091 152.446 78.7267 152.483 78.6103 152.517C78.4966 152.551 78.3688 152.581 78.2267 152.606C78.0847 152.632 77.9441 152.655 77.8049 152.675C77.6657 152.694 77.5449 152.711 77.4426 152.726C77.2125 152.757 77.0066 152.808 76.8248 152.879C76.6429 152.95 76.4995 153.05 76.3944 153.177C76.2892 153.302 76.2367 153.464 76.2367 153.663C76.2367 153.947 76.3404 154.162 76.5478 154.307C76.7551 154.452 77.0194 154.524 77.3404 154.524ZM85.2154 148.98V150.173H81.4526V148.98H85.2154ZM82.3816 147.412H83.9242V153.557C83.9242 153.764 83.9554 153.923 84.0179 154.034C84.0833 154.142 84.1685 154.216 84.2736 154.256C84.3787 154.295 84.4952 154.315 84.623 154.315C84.7196 154.315 84.8077 154.308 84.8873 154.294C84.9696 154.28 85.0321 154.267 85.0748 154.256L85.3347 155.461C85.2523 155.49 85.1344 155.521 84.981 155.555C84.8304 155.589 84.6458 155.609 84.427 155.615C84.0407 155.626 83.6926 155.568 83.383 155.44C83.0733 155.309 82.8276 155.108 82.6458 154.835C82.4668 154.562 82.3787 154.221 82.3816 153.812V147.412ZM88.389 155.657C87.9743 155.657 87.6007 155.584 87.2683 155.436C86.9387 155.285 86.6774 155.064 86.4842 154.771C86.2939 154.479 86.1987 154.118 86.1987 153.689C86.1987 153.319 86.2669 153.014 86.4032 152.773C86.5396 152.531 86.7257 152.338 86.9615 152.193C87.1973 152.048 87.4629 151.939 87.7583 151.865C88.0566 151.788 88.3649 151.733 88.6831 151.699C89.0666 151.659 89.3777 151.623 89.6163 151.592C89.8549 151.558 90.0282 151.507 90.1362 151.439C90.247 151.368 90.3024 151.258 90.3024 151.111V151.085C90.3024 150.764 90.2072 150.515 90.0169 150.339C89.8265 150.163 89.5524 150.075 89.1944 150.075C88.8166 150.075 88.5169 150.157 88.2953 150.322C88.0765 150.487 87.9288 150.682 87.8521 150.906L86.4118 150.702C86.5254 150.304 86.7129 149.971 86.9743 149.704C87.2356 149.434 87.5552 149.233 87.9331 149.099C88.3109 148.963 88.7285 148.895 89.1859 148.895C89.5012 148.895 89.8152 148.932 90.1277 149.006C90.4402 149.079 90.7257 149.202 90.9842 149.372C91.2427 149.54 91.4501 149.768 91.6064 150.058C91.7654 150.348 91.845 150.71 91.845 151.145V155.525H90.362V154.626H90.3109C90.2172 154.808 90.085 154.979 89.9146 155.138C89.747 155.294 89.5353 155.42 89.2797 155.517C89.0268 155.611 88.7299 155.657 88.389 155.657ZM88.7896 154.524C89.0993 154.524 89.3677 154.463 89.595 154.341C89.8223 154.216 89.997 154.051 90.1191 153.846C90.2441 153.642 90.3066 153.419 90.3066 153.177V152.406C90.2583 152.446 90.176 152.483 90.0595 152.517C89.9458 152.551 89.818 152.581 89.676 152.606C89.5339 152.632 89.3933 152.655 89.2541 152.675C89.1149 152.694 88.9941 152.711 88.8919 152.726C88.6618 152.757 88.4558 152.808 88.274 152.879C88.0922 152.95 87.9487 153.05 87.8436 153.177C87.7385 153.302 87.6859 153.464 87.6859 153.663C87.6859 153.947 87.7896 154.162 87.997 154.307C88.2044 154.452 88.4686 154.524 88.7896 154.524Z"
                  fill="#787878"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_12999_3597"
                    x1="67.381"
                    y1="62.5119"
                    x2="19.9364"
                    y2="15.0668"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="white" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_12999_3597"
                    x1="54.8129"
                    y1="76.0179"
                    x2="40.1511"
                    y2="61.3564"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#C2CECE" stop-opacity="0" />
                    <stop
                      offset="0.179"
                      stop-color="#AFBCBC"
                      stop-opacity="0.179"
                    />
                    <stop offset="1" stop-color="#5B6A6A" />
                  </linearGradient>
                  <linearGradient
                    id="paint2_linear_12999_3597"
                    x1="64.2625"
                    y1="60.3164"
                    x2="64.2625"
                    y2="117.849"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#EEF0F4" />
                    <stop offset="0.927" stop-color="#E4E4E4" />
                  </linearGradient>
                  <clipPath id="clip0_12999_3597">
                    <rect
                      width="94.5251"
                      height="94.5251"
                      fill="white"
                      transform="translate(17 25)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>

            <!-- :process_data="vue_universal_table.process_data" -->
            <!-- <vue-universal-table
              api_url="/api/reports/summary-labelmaker"
              :filter="vue_universal_table.filter"
              :fields="vue_universal_table.fields"
              :buttons="vue_universal_table.buttons"
              :update="vue_universal_table.update"
              :infinite_scroll="true"
              sort_order="DESC"
              sort_by="scan_date"
            >
            </vue-universal-table> -->
          </div>
        </div>
      </div>
    </div>
    <hr />
    <!-- Label Maker Table End -->

    <!-- Oil Maker Table Start -->
    <div class="bg-white shadow box-content mt-3 mb-5">
      <div class="row">
        <div class="col-md-6" style="align-self: center">
          <h4 class="text-left" style="margin-bottom: 0">Report Oil Maker</h4>
        </div>
        <div class="row col-md-6 justify-content-end" style="padding-right: 0">
          <div class="col-md-5">
            <MultiSelect
              v-model="filter.sumOilMaker.oilmaker"
              :options="options.sumOilMaker.oilmaker"
              :deselect-label="''"
              :select-label="''"
              placeholder="All Oil Maker"
              class="elegant-multiselect"
            />
          </div>
          <div class="col-md-4">
            <MultiSelect
              v-model="filter.sumOilMaker.year"
              :options="options.year"
              :deselect-label="''"
              :select-label="''"
              :allowEmpty="false"
              placeholder="All Years"
              class="elegant-multiselect"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div>
            <sumOilMaker
              :data="data.sumOilMaker"
              v-if="!isAllZeroOilMaker"
            ></sumOilMaker>
            <div v-else class="text-center mt-5 mb-5">
              <svg
                width="138"
                height="159"
                viewBox="0 0 138 159"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="63.6879"
                  cy="53.6313"
                  r="53.6313"
                  fill="#EAECF0"
                  fill-opacity="0.5"
                />
                <circle
                  cx="7.37485"
                  cy="13.4081"
                  r="5.36313"
                  fill="#F2F4F7"
                  fill-opacity="0.5"
                />
                <circle
                  cx="122.683"
                  cy="84.4696"
                  r="4.02235"
                  fill="#F2F4F7"
                  fill-opacity="0.5"
                />
                <circle
                  cx="6.70391"
                  cy="92.5145"
                  r="6.70391"
                  fill="#F2F4F7"
                  fill-opacity="0.5"
                />
                <circle
                  cx="130.725"
                  cy="25.4754"
                  r="6.70391"
                  fill="#F2F4F7"
                  fill-opacity="0.5"
                />
                <circle
                  cx="117.99"
                  cy="7.37438"
                  r="4.69274"
                  fill="#F2F4F7"
                  fill-opacity="0.5"
                />
                <g clip-path="url(#clip0_12999_3597)">
                  <path
                    d="M102.05 42.3086H28.3141C27.3193 42.3092 26.3654 42.7047 25.662 43.4081C24.9586 44.1115 24.5631 45.0654 24.5625 46.0602V113.714C24.5631 114.709 24.9586 115.662 25.662 116.366C26.3654 117.069 27.3193 117.465 28.3141 117.465H102.05C103.045 117.465 103.999 117.069 104.703 116.366C105.406 115.663 105.802 114.709 105.802 113.714V46.0602C105.802 45.0653 105.406 44.1114 104.703 43.4079C103.999 42.7045 103.045 42.3091 102.05 42.3086Z"
                    fill="#C6C6C6"
                  />
                  <path
                    d="M97.1948 93.9554H33.1676C31.0958 93.9554 29.416 92.2757 29.416 90.2038V30.4283C29.416 28.3565 31.0958 26.6768 33.1676 26.6768H97.1948C99.2666 26.6768 100.946 28.3565 100.946 30.4283V90.2038C100.946 92.2757 99.2666 93.9554 97.1948 93.9554Z"
                    fill="#F0F0F0"
                  />
                  <path
                    d="M30.6038 91.3912V31.6161C30.6038 29.5443 32.2835 27.8645 34.3553 27.8645H98.3826C99.1144 27.8645 99.7946 28.0772 100.371 28.4394C99.7082 27.3818 98.5352 26.6768 97.1948 26.6768H33.1676C31.0958 26.6768 29.416 28.3565 29.416 30.4283V90.2038C29.416 91.5446 30.1211 92.7173 31.1787 93.3809C30.8165 92.8037 30.6038 92.1234 30.6038 91.3916V91.3912Z"
                    fill="url(#paint0_linear_12999_3597)"
                  />
                  <path
                    d="M89.3178 39.3066H41.0469V42.0576H89.3178V39.3066ZM89.3178 49.8106H41.0469V52.5615H89.3178V49.8106ZM89.3178 60.3168H41.0469V63.0677H89.3178V60.3168ZM89.3178 70.8207H41.0469V73.572H89.3178V70.8207Z"
                    fill="white"
                  />
                  <path
                    d="M46.7988 61.9414L58.9287 74.0716H46.7988V61.9414Z"
                    fill="url(#paint1_linear_12999_3597)"
                  />
                  <path
                    d="M105.802 75.0728V47.1635L100.947 42.3086V75.0724H105.802V75.0728Z"
                    fill="#C6C6C6"
                  />
                  <path
                    d="M111.488 77.5975L106.257 114.622C105.996 116.473 104.412 117.849 102.543 117.849H27.8204C25.9512 117.849 24.3671 116.473 24.1056 114.622L17.0375 64.5929C16.7187 62.3344 18.4713 60.3164 20.7523 60.3164H43.8281C45.6973 60.3164 47.2813 61.6921 47.5428 63.5427L48.4691 70.0943C48.7306 71.9453 50.3146 73.321 52.1838 73.321H107.774C110.054 73.321 111.807 75.3389 111.488 77.5975H111.488Z"
                    fill="url(#paint2_linear_12999_3597)"
                  />
                  <path
                    d="M92.9571 101.333H37.4084C37.104 101.333 36.81 101.222 36.5816 101.021C36.3532 100.819 36.206 100.542 36.1676 100.24L35.4726 94.7371C35.4505 94.5611 35.4661 94.3824 35.5184 94.2128C35.5706 94.0433 35.6584 93.8868 35.7757 93.7537C35.893 93.6207 36.0373 93.5141 36.199 93.441C36.3607 93.368 36.536 93.3302 36.7135 93.3301H93.6521C93.8295 93.3302 94.0048 93.368 94.1665 93.441C94.3282 93.5141 94.4725 93.6207 94.5898 93.7537C94.7072 93.8868 94.7949 94.0433 94.8471 94.2128C94.8994 94.3824 94.915 94.5611 94.8929 94.7371L94.1979 100.24C94.1595 100.542 94.0124 100.819 93.784 101.021C93.5555 101.222 93.2616 101.333 92.9571 101.333Z"
                    fill="#D5D5D5"
                  />
                </g>
                <path
                  d="M54.4292 146.798V155.525H53.0229L48.9107 149.581H48.8382V155.525H47.2573V146.798H48.6721L52.78 152.747H52.8567V146.798H54.4292ZM58.9387 155.653C58.2995 155.653 57.7456 155.513 57.2768 155.231C56.8081 154.95 56.4444 154.557 56.1859 154.051C55.9302 153.545 55.8024 152.954 55.8024 152.278C55.8024 151.602 55.9302 151.01 56.1859 150.501C56.4444 149.993 56.8081 149.598 57.2768 149.317C57.7456 149.035 58.2995 148.895 58.9387 148.895C59.5779 148.895 60.1319 149.035 60.6007 149.317C61.0694 149.598 61.4316 149.993 61.6873 150.501C61.9458 151.01 62.0751 151.602 62.0751 152.278C62.0751 152.954 61.9458 153.545 61.6873 154.051C61.4316 154.557 61.0694 154.95 60.6007 155.231C60.1319 155.513 59.5779 155.653 58.9387 155.653ZM58.9473 154.417C59.2939 154.417 59.5836 154.322 59.8166 154.132C60.0495 153.939 60.2228 153.68 60.3365 153.356C60.4529 153.032 60.5112 152.672 60.5112 152.274C60.5112 151.873 60.4529 151.511 60.3365 151.187C60.2228 150.861 60.0495 150.601 59.8166 150.407C59.5836 150.214 59.2939 150.118 58.9473 150.118C58.5922 150.118 58.2967 150.214 58.0609 150.407C57.8279 150.601 57.6532 150.861 57.5368 151.187C57.4231 151.511 57.3663 151.873 57.3663 152.274C57.3663 152.672 57.4231 153.032 57.5368 153.356C57.6532 153.68 57.8279 153.939 58.0609 154.132C58.2967 154.322 58.5922 154.417 58.9473 154.417ZM69.3865 155.525H66.4292V146.798H69.4462C70.3127 146.798 71.057 146.973 71.6792 147.322C72.3042 147.669 72.7843 148.167 73.1195 148.818C73.4547 149.469 73.6223 150.247 73.6223 151.153C73.6223 152.062 73.4533 152.844 73.1152 153.497C72.78 154.15 72.2956 154.652 71.6621 155.001C71.0314 155.351 70.2729 155.525 69.3865 155.525ZM68.0101 154.157H69.3098C69.9178 154.157 70.4249 154.047 70.8311 153.825C71.2374 153.601 71.5428 153.267 71.7473 152.824C71.9519 152.378 72.0542 151.821 72.0542 151.153C72.0542 150.486 71.9519 149.932 71.7473 149.491C71.5428 149.048 71.2402 148.717 70.8397 148.498C70.4419 148.277 69.9476 148.166 69.3567 148.166H68.0101V154.157ZM76.9398 155.657C76.525 155.657 76.1515 155.584 75.8191 155.436C75.4895 155.285 75.2282 155.064 75.035 154.771C74.8446 154.479 74.7495 154.118 74.7495 153.689C74.7495 153.319 74.8176 153.014 74.954 152.773C75.0904 152.531 75.2765 152.338 75.5123 152.193C75.748 152.048 76.0137 151.939 76.3091 151.865C76.6074 151.788 76.9157 151.733 77.2338 151.699C77.6174 151.659 77.9284 151.623 78.1671 151.592C78.4057 151.558 78.579 151.507 78.687 151.439C78.7978 151.368 78.8532 151.258 78.8532 151.111V151.085C78.8532 150.764 78.758 150.515 78.5676 150.339C78.3773 150.163 78.1032 150.075 77.7452 150.075C77.3674 150.075 77.0676 150.157 76.8461 150.322C76.6273 150.487 76.4796 150.682 76.4029 150.906L74.9625 150.702C75.0762 150.304 75.2637 149.971 75.525 149.704C75.7864 149.434 76.106 149.233 76.4838 149.099C76.8617 148.963 77.2793 148.895 77.7367 148.895C78.052 148.895 78.3659 148.932 78.6784 149.006C78.9909 149.079 79.2765 149.202 79.535 149.372C79.7935 149.54 80.0009 149.768 80.1571 150.058C80.3162 150.348 80.3958 150.71 80.3958 151.145V155.525H78.9128V154.626H78.8617C78.7679 154.808 78.6358 154.979 78.4654 155.138C78.2978 155.294 78.0861 155.42 77.8304 155.517C77.5776 155.611 77.2807 155.657 76.9398 155.657ZM77.3404 154.524C77.65 154.524 77.9185 154.463 78.1458 154.341C78.373 154.216 78.5478 154.051 78.6699 153.846C78.7949 153.642 78.8574 153.419 78.8574 153.177V152.406C78.8091 152.446 78.7267 152.483 78.6103 152.517C78.4966 152.551 78.3688 152.581 78.2267 152.606C78.0847 152.632 77.9441 152.655 77.8049 152.675C77.6657 152.694 77.5449 152.711 77.4426 152.726C77.2125 152.757 77.0066 152.808 76.8248 152.879C76.6429 152.95 76.4995 153.05 76.3944 153.177C76.2892 153.302 76.2367 153.464 76.2367 153.663C76.2367 153.947 76.3404 154.162 76.5478 154.307C76.7551 154.452 77.0194 154.524 77.3404 154.524ZM85.2154 148.98V150.173H81.4526V148.98H85.2154ZM82.3816 147.412H83.9242V153.557C83.9242 153.764 83.9554 153.923 84.0179 154.034C84.0833 154.142 84.1685 154.216 84.2736 154.256C84.3787 154.295 84.4952 154.315 84.623 154.315C84.7196 154.315 84.8077 154.308 84.8873 154.294C84.9696 154.28 85.0321 154.267 85.0748 154.256L85.3347 155.461C85.2523 155.49 85.1344 155.521 84.981 155.555C84.8304 155.589 84.6458 155.609 84.427 155.615C84.0407 155.626 83.6926 155.568 83.383 155.44C83.0733 155.309 82.8276 155.108 82.6458 154.835C82.4668 154.562 82.3787 154.221 82.3816 153.812V147.412ZM88.389 155.657C87.9743 155.657 87.6007 155.584 87.2683 155.436C86.9387 155.285 86.6774 155.064 86.4842 154.771C86.2939 154.479 86.1987 154.118 86.1987 153.689C86.1987 153.319 86.2669 153.014 86.4032 152.773C86.5396 152.531 86.7257 152.338 86.9615 152.193C87.1973 152.048 87.4629 151.939 87.7583 151.865C88.0566 151.788 88.3649 151.733 88.6831 151.699C89.0666 151.659 89.3777 151.623 89.6163 151.592C89.8549 151.558 90.0282 151.507 90.1362 151.439C90.247 151.368 90.3024 151.258 90.3024 151.111V151.085C90.3024 150.764 90.2072 150.515 90.0169 150.339C89.8265 150.163 89.5524 150.075 89.1944 150.075C88.8166 150.075 88.5169 150.157 88.2953 150.322C88.0765 150.487 87.9288 150.682 87.8521 150.906L86.4118 150.702C86.5254 150.304 86.7129 149.971 86.9743 149.704C87.2356 149.434 87.5552 149.233 87.9331 149.099C88.3109 148.963 88.7285 148.895 89.1859 148.895C89.5012 148.895 89.8152 148.932 90.1277 149.006C90.4402 149.079 90.7257 149.202 90.9842 149.372C91.2427 149.54 91.4501 149.768 91.6064 150.058C91.7654 150.348 91.845 150.71 91.845 151.145V155.525H90.362V154.626H90.3109C90.2172 154.808 90.085 154.979 89.9146 155.138C89.747 155.294 89.5353 155.42 89.2797 155.517C89.0268 155.611 88.7299 155.657 88.389 155.657ZM88.7896 154.524C89.0993 154.524 89.3677 154.463 89.595 154.341C89.8223 154.216 89.997 154.051 90.1191 153.846C90.2441 153.642 90.3066 153.419 90.3066 153.177V152.406C90.2583 152.446 90.176 152.483 90.0595 152.517C89.9458 152.551 89.818 152.581 89.676 152.606C89.5339 152.632 89.3933 152.655 89.2541 152.675C89.1149 152.694 88.9941 152.711 88.8919 152.726C88.6618 152.757 88.4558 152.808 88.274 152.879C88.0922 152.95 87.9487 153.05 87.8436 153.177C87.7385 153.302 87.6859 153.464 87.6859 153.663C87.6859 153.947 87.7896 154.162 87.997 154.307C88.2044 154.452 88.4686 154.524 88.7896 154.524Z"
                  fill="#787878"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_12999_3597"
                    x1="67.381"
                    y1="62.5119"
                    x2="19.9364"
                    y2="15.0668"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="white" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_12999_3597"
                    x1="54.8129"
                    y1="76.0179"
                    x2="40.1511"
                    y2="61.3564"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#C2CECE" stop-opacity="0" />
                    <stop
                      offset="0.179"
                      stop-color="#AFBCBC"
                      stop-opacity="0.179"
                    />
                    <stop offset="1" stop-color="#5B6A6A" />
                  </linearGradient>
                  <linearGradient
                    id="paint2_linear_12999_3597"
                    x1="64.2625"
                    y1="60.3164"
                    x2="64.2625"
                    y2="117.849"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#EEF0F4" />
                    <stop offset="0.927" stop-color="#E4E4E4" />
                  </linearGradient>
                  <clipPath id="clip0_12999_3597">
                    <rect
                      width="94.5251"
                      height="94.5251"
                      fill="white"
                      transform="translate(17 25)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <hr /> -->
    <!-- Oil Maker Table End -->

    <!-- Customer Scan Table Start -->
    <!-- <div class="row">
      <div class="col-lg-2 offset-lg-10 col-md-4 offset-md-8 col-12">
        <MultiSelect
          v-model="filter.sumCustomer.year"
          :options="options.year"
          :deselect-label="''"
          :allowEmpty="false"
          placeholder="All Years"
          class="elegant-multiselect"
        />
      </div>
    </div>
    <div class="bg-white shadow box-content mt-3 mb-5">
      <div class="row">
        <div class="col-md-12">
          <h4 class="text-center">Customer Scan</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div>
            <sumCustomer
              :data="data.sumCustomer"
              v-if="data.sumCustomer"
            ></sumCustomer>
          </div>
        </div>
      </div>
    </div>
    <hr /> -->
    <!-- Customer Scan Table End -->

    <!-- Claim MD Table Start -->
    <!-- <div class="row">
      <div class="col-lg-2 offset-lg-10 col-md-4 offset-md-8 col-12">
        <MultiSelect
          v-model="filter.sumClaimMD.year"
          :options="options.year"
          :deselect-label="''"
          :allowEmpty="false"
          placeholder="All Years"
          class="elegant-multiselect"
        />
      </div>
    </div>
    <div class="bg-white shadow box-content mt-3 mb-5">
      <div class="row">
        <div class="col-md-12">
          <h4 class="text-center">Claim Main Dealer</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div>
            <sumClaimMD
              :data="data.sumClaimMD"
              v-if="data.sumClaimMD"
            ></sumClaimMD>
          </div>
        </div>
      </div>
    </div> -->
    <!-- Claim MD Table End -->
  </div>
</template>

<script>
// import reportByPo from './children/SumLabelMaker'
// import sumLabelMenara from './children/SumLabelMakerMenara'
import sumLabelCahaya from "./children/SumLabelMakerCahaya";
import sumCustomer from "./children/SumCustomerScan";
import sumClaimMD from "./children/SumClaimMD";

import sumCustomerScanDetailed from "./children/SumCustomerScanDetailed.vue";
import sumClaimMDDetailed from "./children/SumClaimMDDetailed.vue";

import qs from "qs";
import sumOilMaker from "./children/SumOilMaker";
import moment from "moment";

export default {
  metaInfo: {
    title: "Summary Report",
  },
  components: {
    // sumLabelMenara,
    sumLabelCahaya,

    sumCustomer,
    sumCustomerScanDetailed,

    sumClaimMD,
    sumClaimMDDetailed,

    sumOilMaker,
  },
  data() {
    let year = new moment().format("YYYY");
    let startDate = moment().startOf("month").format("YYYY-MM-DD");
    let currentDate = moment().format("YYYY-MM-DD");
    
    
    const rangeSeparator = " s/d ";
    const defaultRangeValue = `${startDate}${rangeSeparator}${currentDate}`;

    return {
      rangeSeparator,
      minimumYear: 2022,
      currentYear: year,
      data: {
        sumLabelCahaya: null,
        sumCustomer: null,
        sumClaimMD: null,
        sumOilMaker: null,
      },
      rangePickr: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d-m-y",
        altInputClass: "form-control input elegant-flatpickr",
        locale: {
          rangeSeparator,
        },
        // onReady: (selectedDates, dateStr, instance) => {
        //   // Format initial display if needed
        //   this.updateInputDisplay(instance);
        // },
        // onChange: (selectedDates, dateStr, instance) => {
        //   this.updateInputDisplay(instance);
        // },
      },
      options: {
        year: [],
        sumLabelCahaya: {
          labelmaker: ["Menara", "Cahaya"],
        },
        sumOilMaker: {
          oilmaker: ["IDEMITSU", "FEDERAL", "STC", "TCS", "NIPPON"],
        },
      },
      selected: {
        date: {
          sumCustomer: defaultRangeValue,
          sumClaimMD: defaultRangeValue,
        },
      },
      filter: {
        sumLabelCahaya: {
          year: year,
          labelmaker: null,
        },
        sumOilMaker: {
          year: year,
          oilmaker: null,
        },
        sumCustomer: {
          start: startDate,
          end: currentDate,
        },
        sumClaimMD: {
          start: startDate,
          end: currentDate,
        },
        pagination: false,
      },
      // vue_universal_table: {
      //   fields: [
      //     { title: "Month", variable: "month" },
      //     { title: "PO", variable: "po" },
      //     { title: "Scan", variable: "volume" },
      //     { title: "Active QR", variable: "active_qr" },
      //     { title: "QR Code", variable: "qr_code" },
      //   ],
      //   filter: {
      //     region: null,
      //   },
      //   update: 0,
      // buttons: [
      //   {
      //     title: "viewMap",
      //     class: "fas fa-location",
      //     condition: "data.lat != 'N/A' || data.lng != 'N/A'",
      //   },
      // ],
      // process_data: `
      //                 for (var i in data) {
      //                     data[i].product_name = data[i].product_name ? data[i].product_name : 'N/A'
      //                     data[i].volume = data[i].volume ? (parseInt(data[i].volume))/1000 + ' Lt' : 'N/A'
      //                     data[i].lat = data[i].lat != 0 ? data[i].lat : 'N/A'
      //                     data[i].lng = data[i].lng != 0 ? data[i].lng : 'N/A'
      //                 }
      //             `,
      // },
    };
  },
  mounted() {
    this.fetchAllData();
    // this.total();
    this.generateYearOptions();
  },
  watch: {
    "selected.date.sumCustomer": function (newDate) {
      const { start, end } = this.parseDateRange(newDate);
      this.filter.sumCustomer.start = start;
      this.filter.sumCustomer.end = end;

      console.log(
        `Filter start date: ${this.filter.sumCustomer.start} to filter end date: ${this.filter.sumCustomer.end} `
      );
    },
    "selected.date.sumClaimMD": function (newDate) {
      const { start, end } = this.parseDateRange(newDate);
      this.filter.sumClaimMD.start = start;
      this.filter.sumClaimMD.end = end;

      console.log(
        `Filter start date: ${this.filter.sumClaimMD.start} to filter end date: ${this.filter.sumClaimMD.end} `
      );
    },
    "filter.sumLabelCahaya": {
      deep: true,
      handler: "fetchSumLabelCahaya",
    },
    "filter.sumCustomer": {
      deep: true,
      handler: "fetchSumCustomer",
    },
    "filter.sumClaimMD": {
      deep: true,
      handler: "fetchSumClaimMD",
    },
    "filter.sumOilMaker": {
      deep: true,
      handler: "fetchSumOilMaker",
    },
    // "vue_universal_table.filter.status": {
    //   handler() {
    //     this.vue_universal_table.update++;
    //   },
    // },
  },
  computed: {
    isAllZeroLabelMaker() {
      const sumLabel = this.data.sumLabelCahaya;
      if (!sumLabel || !Array.isArray(sumLabel)) return true;

      return sumLabel.every(
        (item) =>
          item.total_po === 0 &&
          item.total_scan === 0 &&
          item.total_active === 0 &&
          item.total_qr === 0
      );
    },
    isAllZeroOilMaker() {
      const items = this.data.sumOilMaker;
      if (!items || !Array.isArray(items)) return true;

      return items.every(
        (item) =>
          item.total_deactivate === 0 &&
          item.total_scan === 0 &&
          item.total_active === 0 &&
          item.total_qr === 0
      );
    },
  },
  methods: {
    updateInputDisplay(instance) {
      if (instance.selectedDates.length === 2) {
        const [start, end] = instance.selectedDates;
        const startStr = this.formatDate(start, "d M");
        const endStr = this.formatDate(end, "d M Y");
        instance.input.value = `${startStr} - ${endStr}`;
      } else if (instance.selectedDates.length === 1) {
        // Optional: show single date while selecting range
        instance.input.value = this.formatDate(instance.selectedDates[0], "d M Y");
      } else {
        instance.input.value = ""; // or placeholder
      }
    },
    formatDate(date, format) {
      const day = date.getDate();
      const month = date.toLocaleString("en-GB", { month: "short" });
      const year = date.getFullYear();
      return format
        .replace("d", day)
        .replace("M", month)
        .replace("Y", year);
    },
    getRangeSeparator() {
      if (this.rangeSeparator) {
        return this.rangeSeparator;
      }
      if (this.rangePickr && this.rangePickr.locale && this.rangePickr.locale.rangeSeparator) {
        return this.rangePickr.locale.rangeSeparator;
      }
      return " to ";
    },
    parseDateRange(rawDate) {
      if (!rawDate) {
        return { start: "", end: "" };
      }

      const separator = this.getRangeSeparator();
      const normalized = String(rawDate);

      if (separator && normalized.includes(separator)) {
        const parts = normalized.split(separator);
        const start = parts[0] ? parts[0].trim() : "";
        const end = parts.length > 1 && parts[1] ? parts[1].trim() : start;
        return { start, end };
      }

      if (normalized.includes(" to ")) {
        const parts = normalized.split(" to ");
        const start = parts[0] ? parts[0].trim() : "";
        const end = parts.length > 1 && parts[1] ? parts[1].trim() : start;
        return { start, end };
      }

      return { start: normalized.trim(), end: normalized.trim() };
    },
    generateYearOptions() {
      let years = [];

      for (var year = parseInt(this.currentYear); year >= 2021; year--)
        years.push(year);

      this.options.year = years;
    },
    fetchAllData() {
      this.fetchSumCustomer();
      this.fetchSumClaimMD();
      this.fetchSumLabelCahaya();
      this.fetchSumOilMaker();
    },
    //Get Label Maker Cahaya Menara Summary
    fetchSumLabelCahaya() {
      console.log("Check data:", this.data.sumLabelCahaya);

      this.data.sumLabelCahaya = null;

      if (this.filter.sumLabelCahaya.labelmaker) {
        const sumLabelCahaya = this.filter.sumLabelCahaya || {}; // Default to empty object if undefined

        const queryString = qs.stringify(
          {
            year: sumLabelCahaya.year, // Ensure year is passed
            labelmaker: sumLabelCahaya.labelmaker
              ? String(sumLabelCahaya.labelmaker).toUpperCase()
              : null, // Convert to string before calling toUpperCase()
          },
          { skipNulls: true }
        );

        // console.log("Query String:", queryString);

        this.$http
          .get(`/api/reports/summary-labelmaker?${queryString}`)
          .then((resp) => {
            this.data.sumLabelCahaya = resp.data.data;
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        const initialFilter = "ALL_LABEL";

        this.$http
          .get(
            `/api/reports/summary-labelmaker?labelmaker=${initialFilter}&${qs.stringify(
              this.filter.sumLabelCahaya,
              { skipNulls: true, arrayFormat: "comma" }
            )}`
          )
          .then((resp) => {
            this.data.sumLabelCahaya = resp.data.data;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    //Get Customer Summary
    fetchSumCustomer() {
      // console.log(
      //   `Start date: ${this.filter.sumCustomer.start} to current date: ${this.filter.sumCustomer.end} `
      // );

      this.data.sumCustomer = null;

      this.$http
        .get(
          `/api/reports/summary-customer?${qs.stringify(
            this.filter.sumCustomer,
            { skipNulls: true, arrayFormat: "comma" }
          )}`
        )
        .then((resp) => {
          // console.log("API response for total year:", resp.data.data);

          // this.data.sumCustomer = resp.data.data;
          //   console.log(
          //     "total summary customer in January:",
          //     this.data.sumCustomer[0].total
          //   );

          // Format Customer Summary Data

          this.data.sumCustomer = this.formatDataSumCustomer(resp.data.data);

          // console.log("total summary customer:", this.data.sumCustomer);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    formatDataSumCustomer(dataResp) {
      let data = dataResp;
      let totalYear = { month: "Total" };

      for (var i = 0; i < data.length; i++) {
        this.$set(
          data[i],
          "month_name",
          new moment().set("month", data[i].month - 1).format("MMM")
        );
        // console.log(data[i])

        // let keys = Object.keys(data[i])

        for (var j in data[i]) {
          if (j == "month") continue;

          if (totalYear[j] == null) totalYear[j] = 0;

          totalYear[j] += parseInt(data[i][j]);
        }
      }

      const formattedData = Object.entries(totalYear)
        .filter(
          ([key]) =>
            !["month", "total", "null_total", "month_name"].includes(key)
        )
        .map(([key, value]) => ({
          category: key.replace("_total", "").replace("_", " "), // Remove "_total" and replace "_" with space
          value,
        }));

      return formattedData;
    },
    //Get Oil Maker Summary
    fetchSumOilMaker() {
      this.data.sumOilMaker = null;

      if (this.filter.sumOilMaker.oilmaker) {
        this.$http
          .get(
            `/api/reports/summary-oilmaker?${qs.stringify(
              this.filter.sumOilMaker,
              { skipNulls: true, arrayFormat: "comma" }
            )}`
          )
          .then((resp) => {
            this.data.sumOilMaker = resp.data.data;
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        const initialFilter = "ALL_OILMAKER";

        this.$http
          .get(
            `/api/reports/summary-oilmaker?oilmaker=${initialFilter}&${qs.stringify(
              this.filter.sumOilMaker,
              { skipNulls: true, arrayFormat: "comma" }
            )}`
          )
          .then((resp) => {
            this.data.sumOilMaker = resp.data.data;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    //Get MD Claim
    fetchSumClaimMD() {
      this.data.sumClaimMD = null;
      this.$http
        .get(
          `/api/reports/summary-maindealer?${qs.stringify(
            this.filter.sumClaimMD,
            { skipNulls: true, arrayFormat: "comma" }
          )}`
        )
        .then((resp) => {
          this.data.sumClaimMD = this.formatDataClaimMD(resp.data.data);
          console.log("total summary claim MD:", this.data.sumClaimMD);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    formatDataClaimMD(dataResp) {
      let data = dataResp;
      let totalYear = { month: "Total" };

      for (var i = 0; i < data.length; i++) {
        this.$set(
          data[i],
          "month_name",
          new moment().set("month", data[i].month - 1).format("MMM")
        );
        // console.log(data[i])

        // let keys = Object.keys(data[i])

        for (var j in data[i]) {
          if (j == "month") continue;

          if (totalYear[j] == null) totalYear[j] = 0;

          totalYear[j] += parseInt(data[i][j]);
        }
      }

      const capitalizeFirstLetter = (str) =>
        str.charAt(0).toUpperCase() + str.slice(1);

      const formattedData = Object.entries(totalYear)
        .filter(
          ([key]) =>
            !["month", "total", "null_total", "month_name"].includes(key)
        )
        .map(([key, value]) => {
          let formattedCategory = key.replace("_total", "").replace("_", " ");

          return {
            category: ["hso", "mpm"].includes(formattedCategory)
              ? formattedCategory.toUpperCase()
              : capitalizeFirstLetter(formattedCategory),
            value,
          };
        });

      return formattedData;
    },
  },
};
</script>

<style scoped>
h4.text-left {
  font-weight: 400;
} 

.elegant-multiselect ::v-deep .multiselect__placeholder {
  font-weight: 500; 
}

.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
}

.elegant--sub-title {
  font-size: 18px;
  font-weight: 500;
  color: #9f9f9f;
}

.table td,
.table th {
  text-align: center;
}

.box-content {
  padding: 20px;
  border-radius: 10px;
}
</style>
